import * as Yup from 'yup';

export const seasonSchema = Yup.object({
  title: Yup.string().required('El título es requerido'),
  slug: Yup.string().required('El slug es requerido'),
  description: Yup.string().optional(),
  image: Yup.string().optional(),
  startAt: Yup.date().required('La fecha de inicio es requerida'),
  endAt: Yup.date()
    .required('La fecha de fin es requerida')
    .min(Yup.ref('startAt'), 'La fecha de fin debe ser posterior a la fecha de inicio'),
  visible: Yup.boolean().default(false),
  completion_token_id: Yup.number().optional().nullable(),
  coinExpirationDays: Yup.number().optional().nullable().positive('Debe ser un número mayor a 0'),
  extra_data: Yup.object().optional()
});

export type SeasonFormData = {
  title: string;
  slug: string;
  description?: string;
  image?: string;
  startAt: Date;
  endAt: Date;
  visible: boolean;
  completion_token_id?: number | null;
  coinExpirationDays?: number | null;
  extra_data?: {
    [key: string]: any;
  };
};